import { createClient } from "@supabase/supabase-js";

const SUPABASE_URL = "https://whddduomeokqsvovnicn.supabase.co";
const SUPABASE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6IndoZGRkdW9tZW9rcXN2b3ZuaWNuIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzM0MDczNTgsImV4cCI6MjA4ODk4MzM1OH0.Ei6VgKcKQKFFuvzEB3ibJ4Er5uP0dXoSla6hq9iM978";

export const supabase = createClient(SUPABASE_URL, SUPABASE_KEY);